 
import { environment } from './../../../../environments/environment';
import {
    ChangeDetectorRef, 
    Component, 
    DoCheck, 
    EventEmitter, 
    inject, 
    Input, 
    KeyValueDiffers, 
    OnChanges, 
    OnInit, 
    Output, 
    SimpleChanges
} from '@angular/core';

import { Filtering } from 'src/app/service/filtering/filtering';
import { NavigationService } from 'src/app/service/navigation.service';

export enum FormType {
    CREATION,
    EDITION
}

export enum FilterType {
    DROPDOWN,
    MULTISELECT,
    DATE_RANGE
}

export enum InputType {
    TEXT,
    ONLY_TEXT,
    TEXTAREA,
    EDIT_TEXT,
    CHECK_BOX_TRISTATE,
    EDIT_TEXTAREA,
    EMPTY,
    PASSWORD,
    DROPDOWN,
    RO_DROPDOWN,
    DROPDOWN_SEARCH,
    DROPDOWN_MULTISELECT_SEARCH,
    MULTISELECT,
    CALENDAR,
    EXTERNAL,
    EDIT_NUMERIC,
    TIME,
    SWITCH,
    RO_SWITCH,
    RO_MD_SWITCH,
    SELECT_BUTTON,
    EDIT_TEXT_MASK,
    TWO_FIELDS_CONCAT,
}

export enum DistributionType {
    COLS,
    ROWS
}

export enum LabelPositionTypes {
    TOP,
    RIGHT,
    BOTTOM
}

@Component({
    selector: 'app-form-builder',
    standalone: false,
    templateUrl: './form-builder.component.html',
    styleUrls: ['./form-builder.component.scss']
})
export class FormBuilderComponent implements OnInit, OnChanges, DoCheck {

    @Input() fields: ItemInterface<any>[] = [];

    @Input() distributionType: DistributionType | undefined;

    @Input() distributionOrder: number[] = [];

    @Input() distributionColumns = 0;

    @Input() model: any;

    @Input() modelChanges: any;

    @Input() modelOld: any;

    @Input() undoEnabled = false;
    
    @Output() formChanges: EventEmitter<any> = new EventEmitter<any>();

    @Output() selectAllcheck: EventEmitter<any> = new EventEmitter<any>();

    public navigationService = inject(NavigationService);
    
    showAudio = false;

    public appName = environment.appName;

    public filterInputParcelas = environment.features.filterInputParcelas;

    public es = {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre',
            'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Borrar'
    };

    public INPUT = InputType;

    public DISTRIBUTIONS = DistributionType;

    public TYPE = FormType;

    public differ;

    public distributedFields: ItemInterface<any>[][] = [];

    public modelChangesStatus: any = {};

    public defaultTextStyles = 'background-color: white; border-radius: 3px; border: 1px solid lightgray; padding: 3px;';

    public userLocale = 'en-US';

    selectAll = false;

    public fieldError: Record<string,string> = {};

    constructor(public differs: KeyValueDiffers, private readonly cdr: ChangeDetectorRef) {
        this.differ = differs.find({}).create();
    }

    ngOnInit(): void {
        if (typeof navigator !== 'undefined' && navigator.language) {
            this.userLocale = navigator.language;
        } else {
            this.userLocale = 'en-US';
        }

        this.modelOld = JSON.parse(JSON.stringify(this.model));

        if (this.haveAllRequiredData() && this.distributionType !== undefined) {
            switch (this.distributionType) {
            case DistributionType.COLS:
                this.setupColumns();
                break;
            case DistributionType.ROWS:
                this.setupRows();
                break;
            }
        }
    }

    ngDoCheck(): void {
        if (this.differ.diff(this.model)) {
            (this.fields).forEach(this.applySelected.bind(this));
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['model']) {
            (this.fields).forEach(this.applySelected.bind(this));
            this.applyTransforms();
        }

        if (changes['fields']) {
            this.cdr.detectChanges();
        }

    }

    getAudio(field: string | number, event: any ): void {
        this.model[field] = event;
    }
    
    private asStr(v: any): string {
        return v === null || v === undefined ? '' : String(v);
    }

    public applySelected(field: ItemInterface<any>): void {
        if (field.values && this.model[field.field ?? 0] !== field.values.selected) {
            let searchOn = [];

            if (field.values.values && field.values.values.length > 0) {
                searchOn = field.values.values;
            } else if (field.values.filtered && field.values.filtered.length > 0) {
                searchOn = field.values.filtered;
            }

            if (field.multiSelect) {
                const modelTokens = this.asStr(this.model[field.field ?? 0]).split(';');
                
                field.values.selected = searchOn
                    .map((it: any) => it.value)
                    .filter((it: any) => it != null)
                    .filter((it: any) => modelTokens.includes(
                    this.asStr(field.valuePrimaryKey ? it[field.valuePrimaryKey] : it)
                    ));
                } else {
                field.values.selected = searchOn
                    .map((it: any) => it.value)
                    .filter((it: any) => it != null)
                    .find((it: any) =>
                    this.asStr(field.valuePrimaryKey ? it[field.valuePrimaryKey] : it) ===
                    this.asStr(this.model[field.field ?? 0])
                    );
                }

        }

        setTimeout(() => {
            this.runFieldFilters();
        }, 1);

    }

    public setConfig(field: any,event: any): void {        

        if(field !== null && field['calendarConfiguration']) {
            const configuration = field['calendarConfiguration'];
            const year = event.year;

            if(configuration.minDate && configuration.maxDate) {
                const configMinDay = configuration.minDate.getDate();
                const configMinMonth = configuration.minDate.getMonth();
                const configMaxDay = configuration.maxDate.getDate();
                const configMaxMonth = configuration.maxDate.getMonth();

                const fieldIndex = this.fields.indexOf(field);

                (this.fields[fieldIndex] as any) ['calendarConfiguration'].minDate = new Date(year, configMinMonth, configMinDay);
                (this.fields[fieldIndex] as any) ['calendarConfiguration'].maxDate = new Date(year, configMaxMonth, configMaxDay);
                
            }
        }
        

        // if (configuration) {

        //     const year = event.year;
        //     // const month = event.month;
        //     // const firstDay = new Date(year, month, 1);
        //     // const lastDay = new Date(year, month + 1, 0);

        //     if(configuration.minDate && configuration.maxDate) {

        //         const configMinDay = configuration.minDate.getDate();
        //         const configMinMonth = configuration.minDate.getMonth();
        //         const configMaxDay = configuration.maxDate.getDate();
        //         const configMaxMonth = configuration.maxDate.getMonth();

        //         this.fields.map((field) => {

        //             console.log(field);
                    
        //             field['calendarConfiguration'].minDate = new Date(year, configMinMonth, configMinDay);
        //             field['calendarConfiguration'].maxDate = new Date(year, configMaxMonth, configMaxDay);
        //         });
        //     }
        // }
    }

    public markFieldAsChanged(field: ItemInterface<any>): void {
        const key = field.field ?? '';

        // ─── Begin validation/tooltips logic ───
        // Required
        if (field.required && !this.model[key]) {
            this.fieldError[key] = `${field.label} es obligatorio`;
        }
        // Email format
        else if (key === 'email' && this.model.email) {
            const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailRe.test(this.model.email)) {
                this.fieldError[key] = 'Formato de correo inválido';
            } else {
                delete this.fieldError[key];
            }
        }
        // Clear error if none of the above
        else {
            delete this.fieldError[key];
        }
        // ─── End validation/tooltips logic ───

        if (field.values) {
            if (field.multiSelect) {
                this.model[key] =
                    (field.values.selected instanceof Array ? field.values.selected : [])
                        .filter((it: any) => it)
                        .map((it: Record<string, any>) => field.valuePrimaryKey
                            ? it[field.valuePrimaryKey]
                            : it)
                        .join(';');
            } else {
                this.model[key] = field.valuePrimaryKey
                    ? ((field.values || {}).selected || {})[field.valuePrimaryKey]
                    : ((field.values || {}).selected);
            }
        }

        setTimeout(() => {
            this.runFieldFilters();
        }, 1);

        this.modelChangesStatus[key] = this.model[key] !== this.modelOld[key];
        this.handelModelChanges();
        this.formChanges.emit(field.field);
    }

    public selectAllRows(field: ItemInterface<any>, checked: boolean) {
        // Determina los valores a utilizar basándose en si se ha aplicado un filtro
        const values: any = field.filter ? field.values.filtered : (field.values.values ? field.values.filtered : []);

        if (checked && field.values.selected.length === values.length) {
        
            console.log('Todos los ítems ya están seleccionados.');
            return; // Salir temprano si no hay necesidad de cambiar el estado de selección
        }
    
        const allSelected = values.filter((it: { value: any; }) => it?.value)
            .map((it: { value: Record<string, any>; }) => it.value[field.valuePrimaryKey ?? 0])
            .join(';');
    
        if (checked) {
            this.model[field.field ?? 0] = allSelected;

            const valoresSeleccionados: any[] = [];

            values.forEach((value: { value: any; }) => {
                valoresSeleccionados.push(value.value);
            });

            field.values.selected = valoresSeleccionados;

        } else {
            this.model[field.field ?? 0] = '';
            field.values.selected = [];
        }
    
        // Actualiza el estado de selección 
        this.selectAll = checked;
    
        this.selectAllcheck.emit(field.field);
    }

    
    public handelModelChanges(): void {
        for (const x in this.model) {
            if (this.modelChangesStatus[x]) {
                this.modelChanges[x] = this.model[x];
            } else {
                if (this.modelChanges[x]) {
                    delete this.modelChanges[x];
                }
            }
        }
    }

    trackByField(index: number, field: ItemInterface<any>) {
        return field.field ? field.field : index;
    }

    handleCalendarSelect(field: ItemInterface<any>, date: Date): void {
        this.markFieldAsChanged(field);

        const cfg = (field as any)['calendarConfiguration'];
            
        if (cfg?.onSelect) {
            cfg.onSelect(date);
        }
    }

    public undoField(field: ItemInterface<any>) {
        if (field.values) {
            field.values.selected = this.modelOld[field.field ?? 0];
            this.markFieldAsChanged(field);
        } else {
            this.model[field.field ?? 0] = this.modelOld[field.field ?? 0];
            this.markFieldAsChanged(field);
        }
    }    

    private runFieldFilters() {
        this.fields
            .filter(it => it.filter instanceof Function)
            .forEach(it => {
                it.values.filtered = (it.multiSelect ? [] : [{label: it.placeholder || '...', value: null}])
                    .concat(it.values.values
                        .filter((j: { value: any; }) => j?.value)
                        .filter(it.filter)
                    );

                if (it.multiSelect) {
                    it.values.selected = (it.values.selected instanceof Array ? it.values.selected : [])
                        .filter((item: any) =>
                            it.values.filtered.map((i: { value: any; }) => i.value).includes(item)
                        );
                }
            });
    }


    private applyTransforms() {
        if (this.fields) {
            this.fields.forEach((field: ItemInterface<any>) => {
                if (field.transform) {
                    field.transform.forEach(transformFunction => {
                        if (transformFunction) {
                            transformFunction(field, this.model);
                        }
                    });
                }
            });
        }
    }

    private haveAllRequiredData(): boolean {
        if (!this.model) {
            this.model = {};
        }

        if (!this.modelChanges) {
            this.modelChanges = {};
        }

        if (!this.modelOld) {
            this.modelOld = {};
        }

        this.distributionType = this.distributionType !== undefined ? this.distributionType
            : DistributionType.ROWS;

        this.distributionOrder = this.distributionOrder ? this.distributionOrder
            : [];

        if (this.distributionType === DistributionType.COLS) {
            this.distributionColumns = this.distributionOrder.length;

            if (this.distributionOrder.length === 0) {
                throw new Error('DISTRIBUTION ORDER ATTRIBUTE NEEDED IN COL MODE');
            }
        } else {
            if (!this.distributionColumns) {
                throw new Error('DISTRIBUTION COLUMNS ATTRIBUTE NEEDED IN ROW MODE');
            }
        }

        return true;
    }

    private setupRows(): void {
        let count = 0;
        let row = 0;

        this.distributedFields = [];
        this.distributedFields[row] = [];

        this.fields.forEach((field) => {
            if (count >= (this.distributionOrder[row] || this.distributionColumns)) {
                count = 0;
                this.distributedFields[++row] = [];
            } 
            if (field.visible !== false) {
                // @ts-ignore
                this.distributedFields[row][count++] = field;
            }
        });
    }

    private setupColumns(): void {
        let count = 0;
        let col = 0;

        this.distributedFields[col] = [];

        this.fields.forEach((field) => {
            if (count >= (this.distributionOrder[col] || this.distributionColumns)) {
                count = 0;
                this.distributedFields[++col] = [];
            }
            // @ts-ignore
            this.distributedFields[col][count++] = field;
        });
    }
}

export interface ItemInterface<T> {
    [key: string]: string | boolean | Function | any;

    calendarView?: any; // Calendar
    calendarDateFormat?: string;

    canSelectAll?: boolean;

    component?: Component;
    
    disabled?: boolean;

    display?: {

        table: boolean;

        form: boolean;

    };

    field?: string;

    name?: string; // Nombre de columna para CSVs.

    filter?: Function;

    hasLabel?: boolean;
    
    hasSelectedAll?: boolean; // Multiselect

    inputType?: InputInterface;

    label?: string;

    labelPosition?: LabelPositionTypes;

    mask?: string;
 
    multiSelect?: boolean; // Multiselect

    placeholder?: string;

    required?: boolean;

    separator?: string;

    style?: any;
    
    remove?: boolean;

    maxLength?: number;
    
    maxHeight?: boolean;

    rows?: number;
    
    cols?: number;

    subField1?: string; // TWO_FIELDS_CONCAT

    subField2?: string; // TWO_FIELDS_CONCAT

    transform?: ((value: T, model: T) => T)[];

    undoEnabled?: boolean;

    validate?: ((value: T) => boolean)[];

    valuePrimaryKey?: string;

    values?: T | ItemValuesInterface<T>

    visible?: boolean;
    hidden?: boolean;
    audio?: boolean;

    helpText?: string;
}

export interface InputInterface {
    type: InputType;
    options?: any;
}

export interface FilterInterface {
    type: FilterType;
    options?: any;
}

export interface DistributionInterface {
    type: DistributionType;
    options?: any;
}

export interface TypeAheadInterface<T> {
    selected: T | null;
    values: ValuesInterface<T>[];
    filtered: FilteredValuesInterface<T>[];
    filterCallback?: Filtering<T>;
    label?: string;
}
export interface ValuesInterface<T> {
    value: T | null; 
    label: string;
}

export interface FilteredValuesInterface<T> {
    value: T | null; 
    label: string; 
    tipo?: string; 
    unidades?: number
}

export interface DropdownInterface<T> {
    label: string;
    value: T | null;
}

export interface ItemValuesInterface<T> {
    data: T[] | T;
    selected: T[] | T | null;
    filtered: T[] | T;
    primaryKey?: string;
    labelKey?: string;
    join?: {
        with: string;
        on: {
            a: string;
            b: string;
        };
    };
}